
 <template lang="">
 <UserLayout :showNavBar="true"   pageTitle="Profilo personale">
    
      <template #page-content="">
        <!-- <v-card
        id="frm-user"
                        class="form-card" 
                        outlined 
                        > -->
        <UserProfile></UserProfile>
        <!-- </v-card> -->
     </template>
 </UserLayout> 
</template>
<script>
import UserProfile from "../components/UserProfile/UserProfile.vue";
import UserLayout from "../layout/UserLayout";
export default {
  components: {
    UserProfile,
    UserLayout,
  },
};
</script>
<style lang="scss">
  .mainPage[isMobile] div#frm-user {
    position: absolute;
    left: 0px;
    margin: 0;
    right: 0px;
    top: -9px;
    padding: 0;
    bottom: 0;
}
  .mainPage{
    padding:0;
    margin: 0;
    position: relative !important;
    left: -10 !important;;
  right: -10;
}
</style> 